import { useEffect, useState } from "react";
import { api } from "../../lib/api";

const when = (s) => new Date(s).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

const Changes = ({ detail }) => {
  if (!detail || typeof detail !== "object") return null;
  const rows = Object.entries(detail).slice(0, 8);
  return (
    <ul className="mt-1 text-xs text-slate-500 space-y-0.5">
      {rows.map(([k, v]) => <li key={k}><span className="text-slate-400">{k.replace("tiers.", "")}</span>: {JSON.stringify(v?.from)} → <span className="text-[#38BDF8]">{JSON.stringify(v?.to)}</span></li>)}
    </ul>
  );
};

export const AuditLog = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/audit").then((r) => setItems(r.data)); }, []);
  if (!items) return <p className="text-slate-500 text-sm">Loading…</p>;
  return (
    <div className="lux-card divide-y divide-white/5" data-testid="audit-log">
      {items.map((a) => (
        <div key={a.id} data-testid={`audit-row-${a.id}`} className="grid md:grid-cols-12 gap-2 p-4 text-sm">
          <span className="md:col-span-3 font-mono-lux text-xs text-slate-500">{when(a.created_at)}</span>
          <div className="md:col-span-6"><p>{a.action}</p><Changes detail={a.detail} /></div>
          <span className="md:col-span-3 text-xs text-slate-400 md:text-right">{a.user_email} · {a.role}</span>
        </div>
      ))}
      {items.length === 0 && <p className="p-6 text-sm text-slate-500">No admin activity recorded yet.</p>}
    </div>
  );
};
